





































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationRules } from "_P/validate";
import { Car, ModificationResponse } from "@/services/index.defs";
import { mask } from "vue-the-mask";

enum ModificationInputState {
    selected = 1,
    writing,
}

@Component({ directives: { mask } })
export default class ModificationInput extends Vue {
    @Prop() car: Car;
    @Prop({ default: false }) disabled: boolean;

    Rules = ValidationRules;
    state = ModificationInputState.selected;
    ModificationInputState = ModificationInputState;

    powerString: string = "";

    //region о темные силы дабл клика. да отчистит эти земли Михаил
    dblclick() {
        this.state = ModificationInputState.writing;
    }
    clicks: number = 0;
    timer: any = null;
    delay: number = 400;
    oneClick(event) {
        this.clicks++;
        if (this.clicks === 1) {
            const self = this;
            this.timer = setTimeout(function () {
                self.clicks = 0;
                console.log("oneclick");
            }, this.delay);
        } else {
            clearTimeout(this.timer);
            console.log("dblclick");
            this.dblclick();
            this.clicks = 0;
        }
    }

    get formattedPower() {
        if (!this.car?.power) return "- кВт";
        let kVt = this.car.power * 0.74;

        return `${kVt.toString().substr(0, 5) ?? "-"} кВт`;
    }
    get entries(): ModificationResponse[] {
        if (
            !this.car.modificationId &&
            !!this.car.power &&
            this.car.power != this.model?.power
        ) {
            this.setNewAnotherModification(this.car.power);
        }
        let array = this.$store.direct.state.dicti.modifications.map((x) => x);
        if (!this.car.yearIssue) return [];
        array = array.filter(
            (x) =>
                (!x.manufactureStart ||
                    x.manufactureStart <= this.car.yearIssue) &&
                (!x.manufactureEnd || x.manufactureEnd >= this.car.yearIssue)
        );
        if (
            array.length == 1 &&
            !array[0].power &&
            this.car.yearIssue?.toString().length == 4
        ) {
            console.log("switch state on writing");
            this.state = ModificationInputState.writing;
        } else {
            console.log("switch state on selected");
            this.state = ModificationInputState.selected;
        }
        return array;
    }

    get model(): ModificationResponse {
        if (!this.car.power) return null;
        return this.$store.direct.state.dicti.modifications.find(
            (x) => x.id == this.car.modificationId && x.power == this.car.power
        );
    }

    set model(v: ModificationResponse) {
        this.car.modificationId = v.id;
        this.car.power = v.power;
    }
    selectOnInput(v) {
        if (!v.id) {
            console.log("switch state on writing");
            this.$nextTick(() => (this.state = ModificationInputState.writing));
        }
    }

    get isDisabled() {
        return this.disabled || this.car.yearIssue?.toString().length != 4;
    }

    modelAnyModification() {
        let res =
            this.$store.direct.state.dicti.modifications.some(
                (x) => x.id == this.car.modificationId
            ) || "error";
        return res;
    }

    onBlur() {
        if (!!this.powerString && !isNaN(+this.powerString)) {
            this.setNewAnotherModification(+this.powerString);
        } else {
            this.setNewAnotherModification(0);
        }
        this.state = ModificationInputState.selected;
        this.powerString = "";
    }

    setNewAnotherModification(power: number) {
        let m = new ModificationResponse();
        m.title = "Другая модификация";
        m.power = power;
        this.$store.direct.state.dicti.modifications.splice(
            this.$store.direct.state.dicti.modifications.findIndex(
                (x) => !x.id
            ),
            1,
            m
        );
        this.model = m;
    }
}
